export enum TemplateId {    
    CenterNddExportable = 1,
    CenterNddRegistered = 2,
    RccapMissedDeadline = 3,
    RccapRequestNew = 4,
    SwapQualityIssue = 5,
    RexmNewNotification = 6,
    XmKitRequest = 14,
    SerologyKitRequest = 16,
    SingleAvoidRexm = 18,
    EmergencySwapNotification = 19,
    DonorCompletedHistoryNoPwlDonor = 20,
    DonorCompletedHistoryNoPwlCenter = 21,
    PwlReadyToStart = 22,
    PwlJugArrivedCheckOne = 23,
    PwlJugArrivedCheckTwo = 24,
    PwlJugGotOwnCheck = 25,
    PwlReadyForLabsCheck = 26,
    PwlScripInstructions = 27,
    PwlScripReminder = 28,
    PwlScripExpiring = 29,
    PwlMissingQuestLabs = 30,
    PwlLabResultsAreInReferral = 31,
    PwlLabResultsAreInDash = 32,
    PwlLabResultsAreInReferralReminder = 33,
    PwlLabNotifyReferralWithJug = 34,
    PwlLabNotifyReferralWithLabs = 35,
    PwlLabResultsDashNotification = 36,
    JugOnlyArrivalNotification = 37,
    PwlScripInstructionsPhlebot = 38
}